import { createContext, useContext } from "react";

export const DocumentEditorContext = createContext<{
  enabled: boolean;
  active?: boolean;
  openInWindow?: (artifactId: string) => void;
  open: (artifactId: string) => void;
} | null>(null);
export function useDocumentEditor() {
  return useContext(DocumentEditorContext);
}
export function isEditableDocument(name: string) {
  return /\.(docx|xlsx|pptx)$/i.test(name);
}
